import { Component, OnInit } from "@angular/core";
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
  SearchType,
  SliderType,
} from "@cvx/nextpage";
import { ILoggedInUser } from "./interfaces/common/loggedInUser";
import { LoggedInUserService } from "./services/common/logged-in-user.service";
import { CalAngularService } from "@cvx/cal-angular";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
})
export class AppComponent implements OnInit {
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  SearchType = SearchType;
  SliderType = SliderType;

  constructor(
    private NP: NextPageService,
    private loggedInUserService: LoggedInUserService,
    private authService: CalAngularService
  ) {
    this.NP.options.sitename = "eCash - imprest request system";
    this.setLoggedUserInfo();
  }

  ngOnInit() { }

  setLoggedUserInfo() {
  if (this.authService.isUserSignedIn()) {
    let accountInfo = this.authService.getAccount();

    var logOnName = this.authService.cvxClaimsPrincipal.logOnName
    const userRoles = accountInfo.idTokenClaims.roles.filter(role => role !== "Admin" && role !== "Report");
    
    if (userRoles.length > 1) {
      console.warn("User has too many roles defined, first one taken into account only!");
    }
    
    const userRole = userRoles.length > 0 ? userRoles[0] : null;

    if (userRole === null) {
      console.warn("User has no role defined!");
    }

    const loggedUserData: ILoggedInUser = {
      userEmail: accountInfo.username,
      userRole: userRole,
      readRight: true,
      reportRight: accountInfo.idTokenClaims.roles.includes("Report") ? true : false,
      adminRight: accountInfo.idTokenClaims.roles.includes("Admin") ? true : false,
      userName: accountInfo.name,
      logOnName: logOnName,
    };

    this.loggedInUserService.setCurrentUser(loggedUserData);
  } else {
    this.authService.userInitiatedSignIn();
  }
}
}